import * as Sentry from "@sentry/browser";

import { SENTRY_DSN } from "./config.js";
import { i18nPromise } from "./i18n";
import "../css/normalize.css";
import "../css/vendor-webflow.css";
import "../css/yenda.css";
import signinView from "./views/signinView";

/* eslint-disable */
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    // Send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
});
/* eslint-enable */

// Call init function as soon as the program starts
const init = function () {
  signinView.togglePassword();
  signinView.togglePasswordBtn();
  signinView.renderValidation();
  signinView.initSubmitBtn();
};

// Create an async function to start the application
const startApp = async () => {
  // Sync submit state immediately to avoid flicker while i18n loads.
  signinView.toggleSubmitButton();

  try {
    // Wait for i18next to be fully initialized
    await i18nPromise;

    // Now that translations are ready, run the main app logic
    init();
  } catch (error) {
    // Capture and send the error to Sentry
    Sentry.captureException(error);

    console.error("Failed to initialize the application:", error);
  }
};

// Start the application
startApp();
